/* unplugin-vue-components disabled */import { render } from "./tenant-general.vue?vue&type=template&id=0d246cd7&scoped=true"
import script from "./tenant-general.vue?vue&type=script&lang=js"
export * from "./tenant-general.vue?vue&type=script&lang=js"

import "./tenant-general.vue?vue&type=style&index=0&id=0d246cd7&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d246cd7"],['__file',"src/pages/tenants/settings/tenant-general.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d246cd7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d246cd7', __exports__)) {
    api.reload('0d246cd7', __exports__)
  }
  
  module.hot.accept("./tenant-general.vue?vue&type=template&id=0d246cd7&scoped=true", () => {
    api.rerender('0d246cd7', render)
  })

}


export default __exports__